import { TextField as MuiTextField } from "@mui/material";
import { styled } from "@mui/system";

import { PrintOnlyTypography } from "components/formFields/PrintOnlyTypography";

const PrintHiddenTextField = styled(MuiTextField)({
  "@media print": { display: "none" },
});

export function PrintFriendlyTextField(props) {
  const { value } = props;
  return (
    <>
      <PrintOnlyTypography>{value}</PrintOnlyTypography>
      <PrintHiddenTextField {...props} />
    </>
  );
}
